<template>
  <div class="main-wrap">
    <div class="desc">
      <span>春暖花开！又到了心思活络想折腾各种奇怪东西的季节，尤其是需求金字塔的最低层，现代宅家生活不可或缺的无形基石：Wi-Fi！相信大家不管装修还是租房，肯定或多或少都被布网、选择路由器的问题困扰过。这次我们把家庭Wi-Fi这件事儿一次性说清楚，小白也能轻松上手！</span>
      <div>
        <img src="@/assets/huaweiWifi/pc/wh.png" alt="">
      </div>
    </div>

    <div class="product-list">

      <template  v-for="item in data">
        <div class="line"></div>
        <div class="product-card">
          <div class="img-box">
            <img class="cover" :src="item.cover" alt="">
          </div>
          <div class="product-txt">
            <div class="t-bg">
              <img :src="item.bg" alt="">
            </div>
            <div class="title">
              {{item.title}}
            </div>
            <div class="p-desc">
              {{item.desc}}
            </div>
            <div class="btn">
              <a :href="item.link" target="_blank">查看</a>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// import Swiper from 'swiper';

import vTitle from "../components/title.vue";
import SwiperNews from "../components/swiper-news.vue";
import { request } from '@/assets/common/js/wxShare/api';

export default {
  name: "Index",
  components: {
    vTitle,
    SwiperNews,
  },
  data() {
    return {
      //职场办公
      data: [
        // 极果
        {title: "全屋wifi攻略#1：如何实现全屋wifi覆盖无死角？所有方案一次说清！", desc: "相信各位不管装修、租房，肯定或多或少都被布网、选择路由器的问题困扰过！如何既轻松又完美地搞定全屋Wi-Fi组网？今天婉婉就把家庭Wi-Fi这件事儿说清楚，小白也能轻松上手！", link: "https://www.jiguo.com/video/video/115736.html", bg: "https://cdn.jiguo.com/special/images/huaweiWifi/bg_1.png", cover: "https://cdn.jiguo.com/special/images/huaweiWifi/mb_1.png"},
        {title: "全屋wifi攻略#2：市面上子母路由器有什么区别？选对产品不踩雷", desc: "家里适合哪款路由器？全屋Wi-Fi方案怎么选？信号要好、速度要快、覆盖又要广……估计这也是很多人头疼的问题。上期我们讲到了全屋Wi-Fi的各种组网方案，第二期婉婉就给大家盘盘如何选择稳定可靠的产品——但是选之前一定擦亮双眼，注意避坑哦～", link: "https://www.jiguo.com/video/video/115767.html",bg: "https://cdn.jiguo.com/special/images/huaweiWifi/bg_2.png", cover: "https://cdn.jiguo.com/special/images/huaweiWifi/mb_2.png"},
        {title: "全屋wifi攻略#3：不拆墙不走明线怎么拥有好网络？四大痛点逐个击破", desc: "其实布局全屋Wi-Fi方案，最重要的是了解房型、户型，对症下药。其中最让人头大无外乎墙多墙厚，还有还有旧房改造、精装房中经常涉及到的网口、网线问题……实际生活中各种情况你都能遇上，甚至还有可能是几种问题的大集合！如何更灵活地解决？这次婉婉继续带大家整明白，还带来了一套“万能解法”！", link: "https://www.jiguo.com/video/video/115808.html",bg: "https://cdn.jiguo.com/special/images/huaweiWifi/bg_3.png", cover: "https://cdn.jiguo.com/special/images/huaweiWifi/mb_3.png"},
        {title: "全屋wifi攻略#4：路由器配置太麻烦、问题排查难？小白用户的福音来了！", desc: "Wi-Fi信号就像空气和水一样，是我们生活中必不可少的元素。但是，当信号弱、掉线频繁成为日常，生活将会怎样？本视频就来看看婉婉和两位室友，是如何在170㎡大三居的温馨公寓找到了解决方案吧~", link: "https://www.jiguo.com/video/video/115823.html",bg: "https://cdn.jiguo.com/special/images/huaweiWifi/bg_4.png", cover: "https://cdn.jiguo.com/special/images/huaweiWifi/mb_4.png"},
        {title: "全屋wifi攻略#5：养成孩子健康上网好习惯？这功能比拔网线好用!", desc: "随着现在小朋友使用网络学习和娱乐的需求越来越多，如何保证自家娃能安全、健康地上网，慢慢变成了不少家长头疼的问题……只是没想到，华为凌霄子母路由 Q6还能通过贴心的儿童上网关怀功能解决这个难题？这么神奇的“省爸省妈”小助手如何操作？来一探究竟吧~", link: "https://www.jiguo.com/video/video/115839.html",bg: "https://cdn.jiguo.com/special/images/huaweiWifi/bg_5.png", cover: "https://cdn.jiguo.com/special/images/huaweiWifi/mb_5.png"},
      ]
    }
  }
};
</script>

<style lang="scss" scoped>
img{
  object-fit: cover;
}
.main-wrap{
  width: 837px;
  margin: 0 auto;
  margin-top: 38px;
  .desc{
    padding: 0 48px;
    font-size: 16px;
    font-weight: 500;
    color: #2C2C2C;
    line-height: 30px;

    display: flex;
    flex-direction: column;

    div{
      display: flex;
      justify-content: flex-end;
      img{
        width: 36px;
        height: 36px;
        opacity: 0.8;
      }
    }
  }

  .line{
    margin-top: 35px;
    width: 837px;
    height: 1px;
    border-bottom: 2px dotted #446F85;
  }
  .product-list{
    padding-bottom: 100px;
    margin-top: 39px;
    .product-card{
      margin-top: 36px;
      display: flex;
      .cover{
        width: 346px;
        height: 215px;
        border-radius: 6px;
      }

      .product-txt{
        margin-left: 25px;
        .t-bg{
          img{
            width: 163px;
            height: 29px;
          }
        }

        .title{
          margin-top: 16px;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          line-height: 25px;
        }

        .p-desc{
          margin-top: 16px;
          font-weight: 500;
          font-size: 16px;
          height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          color: #A86F4F;
          line-height: 22px;
        }

        .btn{
          margin-top: 28px;
          width: 89px;
          height: 36px;
          background: #FE584D;
          border-radius: 4px;
          font-weight: 500;
          font-size: 18px;
          line-height: 36px;
          text-align: center;
          a{
            color: #FFFFFF;
          }
        }
      }

    }
  }
}

.swiper{
  height:100px;
}
</style>